export default __webpack_public_path__ + "static/media/avatar-9.3921191a.jpg";